import { Filter } from '@vrplatform/components';
import { day } from '@vrplatform/utils';
import { Group } from '@mantine/core';
import { useTrustReconciliationByListingTableFilter } from './useTrustReconciliationByListingTableFilter';

export const TrustReconciliationByListingTableFilter = () => {
  return (
    <Group>
      <EndDate />
    </Group>
  );
};

const EndDate = () => {
  const { filter, setFilter } = useTrustReconciliationByListingTableFilter();

  return (
    <Filter.Date
      value={[day(filter.endDate).toDate(), null]}
      clearable={false}
      setValue={(value) =>
        setFilter({
          endDate: value?.[0] ? day(value[0]).yyyymmdd() : null,
        })
      }
      type="single"
    />
  );
};
